import type { FC } from 'react'

import { TrButton } from '@skytech/ui/Table/TrButton'

import Highlight from '@/components/Highlight'

type Props = {
  searchFilter: string
  code: string
  subject: string
  text: string
  onEdit: () => void
}

export const TextTemplateListItem: FC<Props> = ({ searchFilter, code, subject, text, onEdit }) => (
  <TrButton onClick={onEdit}>
    <td className="hidden md:table-cell">
      <Highlight pattern={searchFilter} text={code} />
    </td>
    <td>
      <Highlight pattern={searchFilter} text={subject} />
    </td>
    <td className="hidden md:table-cell">
      <Highlight pattern={searchFilter} text={text} />
    </td>
  </TrButton>
)
